import axios from "../http";

class YCC {
  // 易仓储操作人员列表
  static getYCCOperatorList(params = {}) {
    const url = `/zwy/api/ecc/operator/list`;
    return axios.get(url, { params }).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 新增易仓储操作人员
  static postAddYCCOperator(data) {
    const url = `/zwy/api/ecc/operator/save`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 编辑易仓储操作人员
  static postUpdateYCCOperator(data) {
    const url = `/zwy/api/ecc/operator/update`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 关闭易仓储操作人员
  static postUpdateYCCOperatorStatus(id) {
    const url = `/zwy/api/ecc/operator/delete?id=${id}`;
    return axios.post(url).then(res => {
      return Promise.resolve(res.data);
    });
  }

  // 易仓储部门分配列表
  static getYCCDepartmentList(params = {}) {
    const url = `/zwy/api/ecc/department/list`;
    return axios.get(url, { params }).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 新增易仓储部门分配
  static postAddYCCDepartment(data) {
    const url = `/zwy/api/ecc/department/save`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 编辑易仓储部门分配
  static postUpdateYCCDepartment(data) {
    const url = `/zwy/api/ecc/department/update`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 删除易仓储部门分配
  static postDelYCCDepartment(id) {
    const url = `/zwy/api/ecc/department/delete?id=${id}`;
    return axios.post(url).then(res => {
      return Promise.resolve(res.data);
    });
  }

  // Manager部门权限详情
  static postYCCDepartmentAuthDetails(managerId) {
    const url = `/zwy/api/pc/manager/ecc/department/detail?managerId=${managerId}`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 更新Manager部门权限
  static postYCCDepartmentAuthUpdate(data) {
    const url = `/zwy/api/pc/manager/update/ecc/department`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
}

export default YCC;
